<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="160px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input v-model="dataForm.description" placeholder="描述"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: ['mainContentViewHeight'],
    data() {
      return {
        visible: false,
        dataForm: {
          id: '',
          name: '',
          description: '',
        }
      }
    },
    methods: {
      init(id) {
        this.dataForm.id = id || ''
        this.visible = true
        if (this.dataForm.id) {
          this.$httpReq({
            url: '/demo/get?id=' + this.dataForm.id,
            method: 'get'
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.dataForm.id = data.data.id
            }
          })
        }
      },
      // 表单提交
      dataFormSubmit() {
        console.log(this.dataForm)
        this.$httpReq({
          url: '/demo/save',
          method: 'post',
          data: this.dataForm
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>
